import { ReactNode } from 'react';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md';
}

export function Badge({ children, variant = 'default', size = 'md' }: BadgeProps) {
  const variantStyles = {
    default: 'bg-gray-600 text-gray-200',
    success: 'bg-green-500/20 text-green-400',
    warning: 'bg-yellow-500/20 text-yellow-400',
    error: 'bg-red-500/20 text-red-400',
    info: 'bg-blue-500/20 text-blue-400',
  };

  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
  };

  return (
    <span
      className={`inline-flex items-center font-medium rounded-full ${variantStyles[variant]} ${sizeStyles[size]}`}
    >
      {children}
    </span>
  );
}

// DTC severity badge
export function DTCSeverityBadge({ severity }: { severity: string }) {
  const variant = severity?.toLowerCase() === 'critical'
    ? 'error'
    : severity?.toLowerCase() === 'warning'
    ? 'warning'
    : 'info';

  return <Badge variant={variant} size="sm">{severity || 'Unknown'}</Badge>;
}

// Monitor status badge
export function MonitorStatusBadge({ status }: { status: string }) {
  const variant = status?.toLowerCase() === 'ready'
    ? 'success'
    : status?.toLowerCase() === 'not ready'
    ? 'warning'
    : 'default';

  return <Badge variant={variant} size="sm">{status || 'Unknown'}</Badge>;
}
